import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { authActions, MailCheckType } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";

export const useResetPassword = () => {
  const dispatch = useDispatch();
  const { navigateToPage, navigateToTopPage } = useNavigation();
  const { key } = useParams<{ key: string }>();

  useEffect(() => {
    if (!key) return;

    dispatch(appActions.showLoading());
    dispatch(
      authActions.verifyEmailKey.started({
        key,
        type: MailCheckType.ForgotPasword.valueOf(),
        onComplete: () => dispatch(appActions.hideLoading()),
        onError: navigateToTopPage,
      }),
    );
  }, []);

  const handleResetPassword = useCallback(
    (
      key: string,
      code: string,
      password: string,
      passwordConfirmation: string,
    ) => {
      dispatch(appActions.showLoading());
      dispatch(
        authActions.resetPassword.started({
          key,
          code,
          password,
          password_confirmation: passwordConfirmation,
          // TODO: change to selected language
          lang: "ja",
          onComplete: () => dispatch(appActions.hideLoading()),
          onSuccess: () =>
            dispatch(
              appActions.showModal.started({
                title: "パスワードを更新しました。",
                closeButtonLabel: "トップページへ戻る",
                handleClose: () => {
                  dispatch(appActions.closeModal());
                  navigateToPage(PageRoutes.HOME);
                },
              }),
            ),
        }),
      );
    },
    [],
  );

  return { key, handleResetPassword };
};
